import "../styles/HomeNew.css";

// ── SVG Icons — Pillars ──────────────────────────────────────────────────────

const AccountabilityIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    <rect x="100" y="120" width="400" height="440" rx="24" stroke="currentColor" strokeWidth="28" fill="white" />
    <rect x="210" y="80" width="180" height="80" rx="20" stroke="currentColor" strokeWidth="24" fill="white" />
    <rect x="238" y="100" width="124" height="40" rx="10" fill="currentColor" />
    <polyline points="170,320 260,420 430,240" stroke="currentColor" strokeWidth="44" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <line x1="160" y1="465" x2="440" y2="465" stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
    <line x1="160" y1="505" x2="360" y2="505" stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
  </svg>
);

const PhilanthropyIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    <path d="M200 420 Q200 380 240 370 L360 370 Q400 380 400 420 L380 510 L220 510 Z" fill="currentColor" />
    <ellipse cx="300" cy="372" rx="102" ry="22" fill="currentColor" />
    <line x1="300" y1="370" x2="300" y2="230" stroke="currentColor" strokeWidth="24" strokeLinecap="round" />
    <path d="M300 320 Q210 270 195 175 Q280 168 308 278 Z" fill="currentColor" />
    <path d="M300 270 Q390 220 415 125 Q330 132 298 242 Z" fill="currentColor" />
    <line x1="300" y1="230" x2="260" y2="180" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
    <line x1="300" y1="230" x2="345" y2="175" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
    <line x1="300" y1="230" x2="300" y2="168" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
    <path d="M300 80 Q220 80 180 150" stroke="currentColor" strokeWidth="18" strokeLinecap="round" fill="none" />
    <polygon points="165,138 155,170 188,162" fill="currentColor" />
  </svg>
);

const NurturingIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    <circle cx="300" cy="105" r="50" fill="currentColor" />
    <path d="M195 310 Q195 235 300 225 Q405 235 405 310 L405 395 L195 395 Z" fill="currentColor" />
    <path d="M196 268 Q148 258 105 282 Q86 296 92 318 L132 312 Q148 298 172 294 L196 292 Z" fill="currentColor" />
    <path d="M404 268 Q452 258 495 282 Q514 296 508 318 L468 312 Q452 298 428 294 L404 292 Z" fill="currentColor" />
    <circle cx="110" cy="358" r="32" fill="currentColor" />
    <path d="M66 488 Q66 432 110 424 Q154 432 154 488 L154 506 L66 506 Z" fill="currentColor" />
    <circle cx="490" cy="358" r="32" fill="currentColor" />
    <path d="M446 488 Q446 432 490 424 Q534 432 534 488 L534 506 L446 506 Z" fill="currentColor" />
    <line x1="50" y1="512" x2="550" y2="512" stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
    <path d="M285,58 C285,40 300,36 300,36 C300,36 315,40 315,58 C315,70 300,80 300,80 C300,80 285,70 285,58Z" fill="currentColor" />
    <path d="M265,46 C265,32 278,28 285,36 L300,54 L285,58 C278,50 265,56 265,46Z" fill="currentColor" />
    <path d="M335,46 C335,32 322,28 315,36 L300,54 L315,58 C322,50 335,56 335,46Z" fill="currentColor" />
  </svg>
);

// ── SVG Icons — Quick Links ──────────────────────────────────────────────────

const NewsletterIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    {/* Envelope body */}
    <rect x="80" y="160" width="440" height="300" rx="28" stroke="currentColor" strokeWidth="28" fill="white" />
    {/* Envelope flap / V */}
    <polyline points="80,160 300,330 520,160" stroke="currentColor" strokeWidth="28" strokeLinejoin="round" fill="none" />
    {/* Bottom fold lines */}
    <line x1="80" y1="460" x2="220" y2="320" stroke="currentColor" strokeWidth="22" strokeLinecap="round" />
    <line x1="520" y1="460" x2="380" y2="320" stroke="currentColor" strokeWidth="22" strokeLinecap="round" />
    {/* Mail lines inside */}
    <line x1="170" y1="390" x2="290" y2="390" stroke="currentColor" strokeWidth="18" strokeLinecap="round" opacity="0.35" />
    <line x1="170" y1="425" x2="250" y2="425" stroke="currentColor" strokeWidth="18" strokeLinecap="round" opacity="0.35" />
  </svg>
);

const BoardIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    {/* Center person */}
    <circle cx="300" cy="160" r="68" fill="currentColor" />
    <path d="M170 370 Q170 268 300 252 Q430 268 430 370 L430 420 L170 420 Z" fill="currentColor" />
    {/* Left person */}
    <circle cx="115" cy="260" r="46" fill="currentColor" opacity="0.7" />
    <path d="M35 430 Q35 366 115 354 Q195 366 195 430 L195 460 L35 460 Z" fill="currentColor" opacity="0.7" />
    {/* Right person */}
    <circle cx="485" cy="260" r="46" fill="currentColor" opacity="0.7" />
    <path d="M405 430 Q405 366 485 354 Q565 366 565 430 L565 460 L405 460 Z" fill="currentColor" opacity="0.7" />
    {/* Ground line */}
    <line x1="40" y1="510" x2="560" y2="510" stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
  </svg>
);

const CommitteeIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    {/* Table top */}
    <rect x="100" y="220" width="400" height="30" rx="12" fill="currentColor" />
    {/* Table legs */}
    <rect x="130" y="250" width="24" height="130" rx="10" fill="currentColor" />
    <rect x="446" y="250" width="24" height="130" rx="10" fill="currentColor" />
    {/* Person left */}
    <circle cx="130" cy="148" r="42" fill="currentColor" />
    <path d="M68 222 Q68 172 130 162 Q192 172 192 222 L192 224 L68 224 Z" fill="currentColor" />
    {/* Person center */}
    <circle cx="300" cy="148" r="42" fill="currentColor" />
    <path d="M238 222 Q238 172 300 162 Q362 172 362 222 L362 224 L238 224 Z" fill="currentColor" />
    {/* Person right */}
    <circle cx="470" cy="148" r="42" fill="currentColor" />
    <path d="M408 222 Q408 172 470 162 Q532 172 532 222 L532 224 L408 224 Z" fill="currentColor" />
    {/* Chairs bottom */}
    <rect x="100" y="400" width="90" height="18" rx="8" fill="currentColor" opacity="0.6" />
    <rect x="255" y="400" width="90" height="18" rx="8" fill="currentColor" opacity="0.6" />
    <rect x="410" y="400" width="90" height="18" rx="8" fill="currentColor" opacity="0.6" />
  </svg>
);

const ReportIcon = () => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className="pillar-svg">
    {/* Document */}
    <rect x="120" y="80" width="360" height="460" rx="24" stroke="currentColor" strokeWidth="28" fill="white" />
    {/* Folded corner */}
    <path d="M360 80 L480 190 L360 190 Z" fill="currentColor" opacity="0.25" />
    <path d="M360 80 L480 190 L360 190 Z" stroke="currentColor" strokeWidth="20" strokeLinejoin="round" fill="none" />
    {/* Bar chart inside */}
    <rect x="170" y="370" width="50" height="100" rx="6" fill="currentColor" />
    <rect x="245" y="310" width="50" height="160" rx="6" fill="currentColor" />
    <rect x="320" y="260" width="50" height="210" rx="6" fill="currentColor" />
    <rect x="395" y="320" width="50" height="150" rx="6" fill="currentColor" />
    {/* Title lines */}
    <line x1="170" y1="170" x2="360" y2="170" stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
    <line x1="170" y1="215" x2="300" y2="215" stroke="currentColor" strokeWidth="16" strokeLinecap="round" />
    {/* X-axis */}
    <line x1="155" y1="478" x2="460" y2="478" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
  </svg>
);

// ── Pillar data ──────────────────────────────────────────────────────────────

const PILLARS = [
  {
    label: "Accountability",
    color: "card--purple",
    arrowColor: "pu",
    icon: <AccountabilityIcon />,
    emoji: "📋",
    badge: "Core Pillar",
    desc: "Promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders.",
    href: "https://www.forbettertomorrow.org/about/",
  },
  {
    label: "Sustainable Philanthropy",
    color: "card--pink",
    arrowColor: "pk",
    icon: <PhilanthropyIcon />,
    emoji: "🌱",
    badge: "Core Pillar",
    desc: "We believe in hope and hope for a better tomorrow. We demonstrate in thought and action a firm commitment to social justice and diversity.",
    href: "https://www.forbettertomorrow.org/about/",
  },
  {
    label: "Nurturing Future Generations",
    color: "card--green",
    arrowColor: "gn",
    icon: <NurturingIcon />,
    emoji: "🤝",
    badge: "Core Pillar",
    desc: "We believe in hope and hope for a better tomorrow. We demonstrate in thought and action a firm commitment to social justice and diversity.",
    href: "https://www.forbettertomorrow.org/about/",
  },
];

// ── Quick Links data ─────────────────────────────────────────────────────────

const QUICK_LINKS = [
  {
    label: "News Letters",
    href: "/newsLetter",
    icon: <NewsletterIcon />,
    color: "card--purple",
    accentColor: "var(--pu-500)",
  },
  {
    label: "Board Members",
    href: "/board",
    icon: <BoardIcon />,
    color: "card--pink",
    accentColor: "var(--pk-500)",
  },
  {
    label: "Committees",
    href: "/committee",
    icon: <CommitteeIcon />,
    color: "card--green",
    accentColor: "var(--gn-500)",
  },
  {
    label: "Annual Report",
    href: "/report",
    icon: <ReportIcon />,
    color: "card--purple",
    accentColor: "var(--pu-500)",
  },
];

const BELIEFS = [
  "We believe in hope and hope for a better tomorrow.",
  "We demonstrate in thought and action a firm commitment to social justice and diversity.",
  "We seek to provide support that is both sustainable and culturally sensitive.",
  "We espouse transparency and integrity in all we do.",
  "We collaborate in all endeavors and seek to empower others.",
  "We impart the importance of servant leadership to others, including youth.",
];

const TENETS = [
  "We comprehensively vet all projects, ensuring they are non-political and non-religious;",
  "We create sustainability;",
  "We require representation by a liaison personally known to the board at the site of all global projects;",
  "We provide support using local vendors to enhance local economies;",
  "We ensure that at least 98% of total funds raised go directly toward the projects we support.",
];

export default function About() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner">
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              About<br />
              <span className="hero__accent">Our Mission</span>
            </h1>
            <p className="hero__sub">
              Eliminating the gap between abundance and need — promoting social
              justice through accountable, sustainable philanthropy and nurturing
              future generations of servant leaders.
            </p>
            <div className="hero__pills">
              {PILLARS.map(p => (
                <a key={p.label} href={p.href} className={`pill pill--${p.arrowColor === "pu" ? "purple" : p.arrowColor === "pk" ? "pink" : "green"}`}>
                  {p.label}
                </a>
              ))}
            </div>
            <div className="hero__ctas">
              <a href="https://www.forbettertomorrow.org/about/" className="cta cta--solid">Our Story</a>
              <a href="#pillars" className="cta cta--ghost">Our Pillars ↓</a>
            </div>
          </div>
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">3</span>
              <span className="hstat__l">Core Pillars</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">98%</span>
              <span className="hstat__l">Funds to Projects</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">6</span>
              <span className="hstat__l">Core Beliefs</span>
            </div>
            <div className="hstat hstat--soft">
              <span className="hstat__n">IL</span>
              <span className="hstat__l">Based in Illinois</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── QUICK LINKS ── */}
      <section id="links" className="events">
        <div className="sec-hd">
          <span className="sec-eye">Explore FBT</span>
          <h2 className="sec-h2">Get Involved</h2>
          <p className="sec-sub">Learn more about our leadership, reports, and community updates.</p>
        </div>
        <div className="events__grid" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
          {QUICK_LINKS.map(lk => (
            <a key={lk.label} href={lk.href} className={`ecard ${lk.color}`}>
              <div className="ecard__img" style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "1.2rem",
                height: 140,
              }}>
                <div style={{
                  width: "100px",
                  height: "100px",
                  color: lk.accentColor,
                }}>
                  {lk.icon}
                </div>
              </div>
              <h3 className="ecard__name">{lk.label}</h3>
              <span className="ecard__arrow">View ↗</span>
            </a>
          ))}
        </div>
      </section>

      {/* ── PILLARS ── */}
      <section id="pillars" className="events" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">What We Stand For</span>
            <h2 className="sec-h2">Our Three Pillars</h2>
            <p className="sec-sub">The foundational principles guiding every decision and initiative at FBT.</p>
          </div>
          <div className="events__grid">
            {PILLARS.map(pl => (
              <a key={pl.label} href={pl.href} className={`ecard ${pl.color}`} style={{ alignItems: "flex-start" }}>
                <div className="ecard__icon">{pl.emoji}</div>
                <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
                  <div style={{
                    width: "90px",
                    height: "90px",
                    color: pl.arrowColor === "pu" ? "var(--pu-500)" : pl.arrowColor === "pk" ? "var(--pk-500)" : "var(--gn-500)",
                  }}>
                    {pl.icon}
                  </div>
                </div>
                <span className="ecard__label">{pl.badge}</span>
                <h3 className="ecard__name">{pl.label}</h3>
                <p className="ecard__desc">{pl.desc}</p>
                <span className="ecard__arrow">Learn more →</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* ── QUOTE ── */}
      <div className="quote-band">
        <p>"Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders."</p>
      </div>

      {/* ── BELIEFS & TENETS ── */}
      <section className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "3rem", alignItems: "start" }}>

          {/* Beliefs */}
          <div>
            <div className="sec-hd" style={{ textAlign: "left" }}>
              <span className="sec-eye">What We Believe</span>
              <h2 className="sec-h2">Our Beliefs & Behaviors</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
              {BELIEFS.map((b, i) => (
                <div key={i} className="lcard" style={{ flexDirection: "row", gap: "1rem", alignItems: "flex-start" }}>
                  <span style={{
                    flexShrink: 0,
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    background: i % 3 === 0 ? "var(--pu-100)" : i % 3 === 1 ? "var(--pk-100)" : "var(--gn-100)",
                    color: i % 3 === 0 ? "var(--pu-700)" : i % 3 === 1 ? "var(--pk-700)" : "var(--gn-700)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "var(--ff-head)",
                    fontWeight: 800,
                    fontSize: ".75rem",
                  }}>{i + 1}</span>
                  <p style={{ fontSize: ".87rem", color: "var(--muted)", lineHeight: 1.7 }}>{b}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Tenets */}
          <div>
            <div className="sec-hd" style={{ textAlign: "left" }}>
              <span className="sec-eye">How We Give</span>
              <h2 className="sec-h2">Five Tenets of FBT Giving</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
              {TENETS.map((t, i) => (
                <div key={i} className="lcard" style={{
                  flexDirection: "row", gap: "1rem", alignItems: "flex-start",
                  background: i % 2 === 0 ? "var(--pu-50)" : "var(--pk-50)",
                  borderColor: i % 2 === 0 ? "var(--pu-200)" : "var(--pk-200)",
                }}>
                  <span style={{
                    flexShrink: 0,
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    background: i % 2 === 0 ? "var(--pu-200)" : "var(--pk-200)",
                    color: i % 2 === 0 ? "var(--pu-700)" : "var(--pk-700)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "var(--ff-head)",
                    fontWeight: 800,
                    fontSize: ".75rem",
                  }}>{i + 1}</span>
                  <p style={{ fontSize: ".87rem", color: "var(--muted)", lineHeight: 1.7 }}>{t}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}